import type { RepositoryHttp } from "@/infrastructure/repositories/http";
import type { IRoutes } from "@/types/src/backend/routes";

type UseCase = IRoutes.Endpoints.Expert.JobOpening.PostTalkToSpecialist;
type Url = UseCase["url"];
type Input = UseCase["body"];
type Output = UseCase["outputData"];

export class UseCasePostTalkToSpecialist {
  constructor(private readonly repository: RepositoryHttp) {}

  public run = async (body: Input) => {
    const url: Url = "/expert/talk-to-specialist";

    const result = await this.repository.create<Input, Output>(
      String(url),
      body,
    );

    return result;
  };
}
